import { ApplicationDataStore } from '../application/ApplicationDataStore';
import { DataItem } from '@servicetitan/financing-utils-shared';
import { ReviewCard } from './ReviewCard';
import { useRef } from 'react';
import { ImperativeForm } from '../common/Form';
import { MailingAddressContainer } from '../mailing-address';

export const MailingAddress = () => {
    const { applicationData } = ApplicationDataStore.useStore();
    const mailingAddress = applicationData.mailingAddress?.primaryApplicant;
    const formattedMailingAddress = `${mailingAddress?.address?.street}<br> ${mailingAddress?.address?.city}, ${mailingAddress?.address?.state} ${mailingAddress?.address?.zip}`;
    const formRef = useRef<ImperativeForm>(null);

    return (
        <ReviewCard title="Mailing Address" formRef={formRef}>
            <ReviewCard.View>
                <DataItem label="Mailing Address" text={formattedMailingAddress} />
            </ReviewCard.View>
            <ReviewCard.Edit>
                <MailingAddressContainer formRef={formRef} />
            </ReviewCard.Edit>
        </ReviewCard>
    );
};
